import { _ as _call_super } from "@swc/helpers/_/_call_super";
import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { _ as _inherits } from "@swc/helpers/_/_inherits";
import dayjs from 'dayjs';
import calendar from 'dayjs/plugin/calendar.js';
import localizedFormat from 'dayjs/plugin/localizedFormat.js';
import updateLocale from 'dayjs/plugin/updateLocale.js';
import { Locales } from '../strings/Locales.js';
import { MissingFormatWithOptions } from './internal/MissingFormat.js';
import { TemporalUtils } from './internal/TemporalUtils.js';
// required for `calendar` to work
dayjs.extend(calendar);
// required for `updateLocale` to work
dayjs.extend(updateLocale);
// required for ll and LLL to work
dayjs.extend(localizedFormat);
dayjs.updateLocale('en', {
    calendar: {
        sameElse: function sameElse(now) {
            return now.diff(this, 'months') > 6 ? this.format(Locales.format('otherCalendarDateShort', {
                date: 'll'
            })) : this.format(Locales.format('otherCalendarDateLong', {
                date: 'll',
                time: 'LT'
            }));
        }
    }
});
export var DayjsCalendarTimeFormat = /*#__PURE__*/ function() {
    "use strict";
    function DayjsCalendarTimeFormat() {
        _class_call_check(this, DayjsCalendarTimeFormat);
    }
    var _proto = DayjsCalendarTimeFormat.prototype;
    _proto.format = function format(value) {
        return TemporalUtils.toDayjs(value).calendar();
    };
    _proto.resolvedOptions = function resolvedOptions() {
        return {
            locale: dayjs.locale()
        };
    };
    return DayjsCalendarTimeFormat;
}();
export var DayjsCalendarTimeMissingFormat = /*#__PURE__*/ function(MissingFormatWithOptions) {
    "use strict";
    _inherits(DayjsCalendarTimeMissingFormat, MissingFormatWithOptions);
    function DayjsCalendarTimeMissingFormat(options) {
        _class_call_check(this, DayjsCalendarTimeMissingFormat);
        return _call_super(this, DayjsCalendarTimeMissingFormat, [
            new DayjsCalendarTimeFormat(),
            options
        ]);
    }
    return DayjsCalendarTimeMissingFormat;
}(MissingFormatWithOptions);

//# sourceMappingURL=DayjsCalendarTimeMissingFormat.js.map